import toCamelCase from '../toCamelCase';

const getNestedSidemenuList = (content) => {
  if (!content.length >= 1) return false;
  const subChapters = content.filter((e) => e.nodeType === 'heading-3');
  if (!subChapters.length >= 1) return false;
  const list = [];
  subChapters.forEach((item, index) => {
    list[index] = {};
    list[index].title = item.content[0].value;
    list[index].id = toCamelCase(item.content[0].value).replace(/[^a-zA-Z ]/g, '');
  });
  return list;
};

export default function getSidemenuData(props) {
  const {
    fields: { whatYoullLearn, whatYoullNeed, theProblem, theHypothesis, theSolution, theImpact },
  } = props;

  const data = {};
  data.list = [];

  const learnings = whatYoullLearn ? {} : false;
  if (learnings) {
    learnings.title = 'What you’ll learn';
    learnings.id = toCamelCase('What youll learn');
    data.list.push(learnings);
  }

  const requirements = whatYoullNeed ? {} : false;
  if (requirements) {
    requirements.title = 'What you’ll need';
    requirements.id = toCamelCase('What youll need');
    requirements.modifier = 'SideMenu-item--last';
    data.list.push(requirements);
  }

  const problemChapter = theProblem ? {} : false;
  if (problemChapter) {
    problemChapter.title = 'The Problem';
    problemChapter.id = toCamelCase(problemChapter.title);
    problemChapter.list = getNestedSidemenuList(theProblem.content);
    data.list.push(problemChapter);
  }

  const hypothesisChapter = theHypothesis ? {} : false;
  if (hypothesisChapter) {
    hypothesisChapter.title = 'The Hypothesis';
    hypothesisChapter.id = toCamelCase(hypothesisChapter.title);
    hypothesisChapter.list = getNestedSidemenuList(theHypothesis.content);
    data.list.push(hypothesisChapter);
  }

  const solutionChapter = theSolution ? {} : false;
  if (solutionChapter) {
    solutionChapter.title = 'The Solution';
    solutionChapter.id = toCamelCase(solutionChapter.title);
    solutionChapter.list = getNestedSidemenuList(theSolution.content);
    data.list.push(solutionChapter);
  }

  const impactData = theImpact ? {} : false;
  if (impactData) {
    impactData.title = 'The Impact';
    impactData.id = toCamelCase(impactData.title);
    impactData.modifier = 'SideMenu-item--last';
    data.list.push(impactData);
  }

  return data.list.length >= 1 ? data : false;
}
